import {
  type ColumnConfig,
  ColumnTable,
  type ColumnTableCellProps,
  type ColumnTableRow,
} from '@terminal/components/column-table';
import clsx from 'clsx';

import styles from './SharedTable.module.scss';

export type SharedTableColumn<T> = ColumnConfig<T>;
export type SharedTableDataItem<T> = ColumnTableRow<T>;
export type SharedTableCellProps<T> = ColumnTableCellProps<T>;

export interface SharedTableProps<T> {
  tableData: SharedTableDataItem<T>[];
  tableColumns: SharedTableColumn<T>[];
  title?: string;
  titleSize?: 'small' | 'large';
  noCellPadding?: boolean;
}

export const SharedTable = <T extends {}>({
  tableData,
  tableColumns,
  title,
  titleSize = 'small',
  noCellPadding = false,
}: SharedTableProps<T>) => {
  const isSmallTitle = titleSize === 'small';
  const hasTitle = !!title;

  return (
    <div
      className={clsx(styles.root, {
        [styles.gapNone]: !hasTitle,
        [styles.gapSmallTitle]: hasTitle && isSmallTitle,
        [styles.gapLargeTitle]: hasTitle && !isSmallTitle,
      })}
    >
      {hasTitle && (
        <div className={isSmallTitle ? styles.titleSmall : styles.titleLarge}>
          {title}
        </div>
      )}
      <div
        className={clsx(styles.smartTableWrapper, {
          [styles.noCellPadding]: noCellPadding,
        })}
      >
        <ColumnTable
          columns={tableColumns}
          data={tableData}
          withBodyRowHover={false}
        />
      </div>
    </div>
  );
};
